import type { BaseActiveFilter } from '../filter-supporters/stores/filterStoreSlice'

export type SearchFilterInput = Record<string, BaseActiveFilter['values']>

const toCamelCase = (str: string) => str.replace(/[-_\s]+(.)/g, (_match, char) => char.toUpperCase())

const convertFiltersToQueryInputs = (filters: BaseActiveFilter[] | undefined): SearchFilterInput[] =>
  (filters ?? []).map(({ property, predicate, values }) => ({
    [toCamelCase(`${property}_${predicate}`)]: values,
  }))

export const buildFilters = (
  filters: BaseActiveFilter[] | undefined,
  nameSearch: string | undefined
): SearchFilterInput[] => {
  const searchFilters = convertFiltersToQueryInputs(filters)
  if (!nameSearch) return searchFilters
  return searchFilters.concat([{ fullNameICont: nameSearch }])
}
